export default "__VITE_ASSET__CNiqSwrH__"